// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Raleway:400,700);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
	box-sizing: border-box;
	margin: 0;
	padding: 0;	
	font-family: Raleway, sans-serif;
}

body {
	background: linear-gradient(90deg, #C7C5F4, #776BCC);		
}

.container {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 100vh;
}

.screen {		
	background: linear-gradient(90deg, #5D54A4, #7C78B8);		
	position: relative;	
	height: 600px;
	width: 360px;	
	box-shadow: 0px 0px 24px #5C5696;
}

.screen__content {
	z-index: 1;
	position: relative;	
	height: 100%;
}

.screen__background {		
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 0;
	clip-path: inset(0 0 0 0);	
}

.screen__background__shape {
	transform: rotate(45deg);
	position: absolute;
}

.screen__background__shape1 {
	height: 520px;
	width: 520px;
	background: #FFF;	
	top: -50px;
	right: 120px;	
	border-radius: 0 72px 0 0;
}

.screen__background__shape2 {
	height: 220px;
	width: 220px;
	background: #6C63AC;	
	top: -172px;
	right: 0;	
	border-radius: 32px;
}

.screen__background__shape3 {
	height: 540px;
	width: 190px;
	background: linear-gradient(270deg, #5D54A4, #6A679E);
	top: -24px;
	right: 0;	
	border-radius: 32px;
}

.screen__background__shape4 {
	height: 400px;
	width: 200px;
	background: #7E7BB9;	
	top: 420px;
	right: 50px;	
	border-radius: 60px;
}

.login {
	width: 320px;
	padding: 30px;
	padding-top: 156px;
}

.login__field {
	padding: 20px 0px;	
	position: relative;	
}

.login__icon {
	position: absolute;
	top: 30px;
	color: #7875B5;
}

.login__input {
	border: none;
	border-bottom: 2px solid #D1D1D4;
	background: none;
	padding: 10px;
	padding-left: 24px;
	font-weight: 700;
	width: 75%;
	transition: .2s;
}

.login__input:active,
.login__input:focus,
.login__input:hover {
	outline: none;
	border-bottom-color: #6A679E;
}

.login__submit {
	background: #fff;
	font-size: 14px;
	margin-top: 30px;
	padding: 16px 20px;
	border-radius: 26px;
	border: 1px solid #D4D3E8;
	text-transform: uppercase;
	font-weight: 700;
	display: flex;
	align-items: center;
	width: 100%;
	color: #4C489D;
	box-shadow: 0px 2px 2px #5C5696;
	cursor: pointer;
	transition: .2s;
}

.login__submit:active,
.login__submit:focus,
.login__submit:hover {
	border-color: #6A679E;
	outline: none;
}

.button__icon {
	font-size: 24px;
	margin-left: auto;
	color: #7875B5;
}

.social-login {	
	position: absolute;
	height: 140px;
	width: 160px;
	text-align: center;
	bottom: 0px;
	right: 0px;
	color: #fff;
}

.social-icons {
	display: flex;
	align-items: center;
	justify-content: center;
}

.social-login__icon {
	padding: 20px 10px;
	color: #fff;
	text-decoration: none;	
	text-shadow: 0px 0px 8px #7875B5;
}

.social-login__icon:hover {
	transform: scale(1.5);	
}`, "",{"version":3,"sources":["webpack://./src/components/style.css"],"names":[],"mappings":"AAEA;CACC,sBAAsB;CACtB,SAAS;CACT,UAAU;CACV,gCAAgC;AACjC;;AAEA;CACC,oDAAoD;AACrD;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,iBAAiB;AAClB;;AAEA;CACC,oDAAoD;CACpD,kBAAkB;CAClB,aAAa;CACb,YAAY;CACZ,gCAAgC;AACjC;;AAEA;CACC,UAAU;CACV,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,UAAU;CAEV,yBAAyB;AAC1B;;AAEA;CACC,wBAAwB;CACxB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,gBAAgB;CAChB,UAAU;CACV,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,mBAAmB;CACnB,WAAW;CACX,QAAQ;CACR,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,qDAAqD;CACrD,UAAU;CACV,QAAQ;CACR,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,mBAAmB;CACnB,UAAU;CACV,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,gCAAgC;CAChC,gBAAgB;CAChB,aAAa;CACb,kBAAkB;CAClB,gBAAgB;CAChB,UAAU;CACV,eAAe;AAChB;;AAEA;;;CAGC,aAAa;CACb,4BAA4B;AAC7B;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,yBAAyB;CACzB,yBAAyB;CACzB,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,WAAW;CACX,cAAc;CACd,+BAA+B;CAC/B,eAAe;CACf,eAAe;AAChB;;AAEA;;;CAGC,qBAAqB;CACrB,aAAa;AACd;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,YAAY;CACZ,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,qBAAqB;CACrB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Raleway:400,700');\n\n* {\n\tbox-sizing: border-box;\n\tmargin: 0;\n\tpadding: 0;\t\n\tfont-family: Raleway, sans-serif;\n}\n\nbody {\n\tbackground: linear-gradient(90deg, #C7C5F4, #776BCC);\t\t\n}\n\n.container {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmin-height: 100vh;\n}\n\n.screen {\t\t\n\tbackground: linear-gradient(90deg, #5D54A4, #7C78B8);\t\t\n\tposition: relative;\t\n\theight: 600px;\n\twidth: 360px;\t\n\tbox-shadow: 0px 0px 24px #5C5696;\n}\n\n.screen__content {\n\tz-index: 1;\n\tposition: relative;\t\n\theight: 100%;\n}\n\n.screen__background {\t\t\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: 0;\n\t-webkit-clip-path: inset(0 0 0 0);\n\tclip-path: inset(0 0 0 0);\t\n}\n\n.screen__background__shape {\n\ttransform: rotate(45deg);\n\tposition: absolute;\n}\n\n.screen__background__shape1 {\n\theight: 520px;\n\twidth: 520px;\n\tbackground: #FFF;\t\n\ttop: -50px;\n\tright: 120px;\t\n\tborder-radius: 0 72px 0 0;\n}\n\n.screen__background__shape2 {\n\theight: 220px;\n\twidth: 220px;\n\tbackground: #6C63AC;\t\n\ttop: -172px;\n\tright: 0;\t\n\tborder-radius: 32px;\n}\n\n.screen__background__shape3 {\n\theight: 540px;\n\twidth: 190px;\n\tbackground: linear-gradient(270deg, #5D54A4, #6A679E);\n\ttop: -24px;\n\tright: 0;\t\n\tborder-radius: 32px;\n}\n\n.screen__background__shape4 {\n\theight: 400px;\n\twidth: 200px;\n\tbackground: #7E7BB9;\t\n\ttop: 420px;\n\tright: 50px;\t\n\tborder-radius: 60px;\n}\n\n.login {\n\twidth: 320px;\n\tpadding: 30px;\n\tpadding-top: 156px;\n}\n\n.login__field {\n\tpadding: 20px 0px;\t\n\tposition: relative;\t\n}\n\n.login__icon {\n\tposition: absolute;\n\ttop: 30px;\n\tcolor: #7875B5;\n}\n\n.login__input {\n\tborder: none;\n\tborder-bottom: 2px solid #D1D1D4;\n\tbackground: none;\n\tpadding: 10px;\n\tpadding-left: 24px;\n\tfont-weight: 700;\n\twidth: 75%;\n\ttransition: .2s;\n}\n\n.login__input:active,\n.login__input:focus,\n.login__input:hover {\n\toutline: none;\n\tborder-bottom-color: #6A679E;\n}\n\n.login__submit {\n\tbackground: #fff;\n\tfont-size: 14px;\n\tmargin-top: 30px;\n\tpadding: 16px 20px;\n\tborder-radius: 26px;\n\tborder: 1px solid #D4D3E8;\n\ttext-transform: uppercase;\n\tfont-weight: 700;\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n\tcolor: #4C489D;\n\tbox-shadow: 0px 2px 2px #5C5696;\n\tcursor: pointer;\n\ttransition: .2s;\n}\n\n.login__submit:active,\n.login__submit:focus,\n.login__submit:hover {\n\tborder-color: #6A679E;\n\toutline: none;\n}\n\n.button__icon {\n\tfont-size: 24px;\n\tmargin-left: auto;\n\tcolor: #7875B5;\n}\n\n.social-login {\t\n\tposition: absolute;\n\theight: 140px;\n\twidth: 160px;\n\ttext-align: center;\n\tbottom: 0px;\n\tright: 0px;\n\tcolor: #fff;\n}\n\n.social-icons {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.social-login__icon {\n\tpadding: 20px 10px;\n\tcolor: #fff;\n\ttext-decoration: none;\t\n\ttext-shadow: 0px 0px 8px #7875B5;\n}\n\n.social-login__icon:hover {\n\ttransform: scale(1.5);\t\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
